import { render, staticRenderFns } from "./NsPp.vue?vue&type=template&id=ffd00bc0"
import script from "./NsPp.vue?vue&type=script&lang=js"
export * from "./NsPp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports